import { Select, Input, Radio, Checkbox, InputNumber, Space, Typography } from 'antd';
import type { FieldMeta } from '../../../api/types';
import type { AttachmentSection } from '../../../contract/types';

// FieldType.Attachment = 17
const ATTACHMENT_TYPE = 17;

interface Props {
  section: AttachmentSection;
  onChange: (s: AttachmentSection) => void;
  fieldMetas: FieldMeta[];
}

export function AttachmentEditor({ section, onChange, fieldMetas }: Props) {
  const attachmentFields = fieldMetas.filter((m) => m.type === ATTACHMENT_TYPE);

  return (
    <Space direction="vertical" size={8} style={{ width: '100%' }}>
      <div>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>附件字段</Typography.Text>
        <Select
          size="small"
          style={{ width: '100%' }}
          placeholder={attachmentFields.length ? '选择附件字段' : '当前表没有附件字段'}
          value={section.fieldId ?? undefined}
          options={attachmentFields.map((m) => ({ value: m.id, label: m.name }))}
          onChange={(fieldId) => onChange({ ...section, fieldId })}
          notFoundContent="当前表没有附件字段"
        />
      </div>
      <div>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>区块标题（可留空）</Typography.Text>
        <Input
          size="small"
          placeholder="如：发票附件"
          value={section.title}
          onChange={(e) => onChange({ ...section, title: e.target.value })}
        />
      </div>
      <div>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>排版</Typography.Text>
        <div>
          <Radio.Group
            size="small"
            value={section.layout}
            onChange={(e) => onChange({ ...section, layout: e.target.value })}
            options={[
              { value: 'full', label: '整宽（发票/凭证）' },
              { value: 'grid2', label: '两列（照片）' },
            ]}
            optionType="button"
          />
        </div>
      </div>
      <Space size={12} wrap>
        <Checkbox
          checked={section.showName}
          onChange={(e) => onChange({ ...section, showName: e.target.checked })}
        >
          显示文件名
        </Checkbox>
        {section.layout === 'full' && (
          <Checkbox
            checked={section.pageBreakEach}
            onChange={(e) => onChange({ ...section, pageBreakEach: e.target.checked })}
          >
            每张单独一页
          </Checkbox>
        )}
      </Space>
      <div>
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>单张最大高度（mm，留空不限）</Typography.Text>
        <InputNumber
          size="small"
          min={20}
          max={280}
          style={{ width: 120, display: 'block' }}
          value={section.maxHeightMm ?? undefined}
          onChange={(v) => onChange({ ...section, maxHeightMm: v ?? null })}
          placeholder="不限"
        />
      </div>
      <Typography.Text type="secondary" style={{ fontSize: 11 }}>
        图片附件会直接排进文档；PDF/Word 等非图片附件将以文件名列表说明随附。
      </Typography.Text>
    </Space>
  );
}
